import _ from "lodash";
import React, { useState } from "react";
import { FieldArray } from "react-final-form-arrays";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import PagesAttributes from "./1_Pages";

const RevisionsAttributes = (props) => {
  const { fields, users,custom_form } = props;


  const [activeTab, setActiveTab] = useState(null);
  const canAddNewRev = !fields.value || fields?.value?.length == 0 || fields.value?.[fields.value.length - 1]?.id ? true : false;

  const cloneRevision = (revisionIndex) => {
    const revision = fields.value[revisionIndex];
    const newRevision = _.cloneDeep(revision);
    newRevision.id = null;
    newRevision.number = fields.value.length + 1;
    newRevision.pages_attributes = _.map(newRevision.pages_attributes, (page) => {
      page.id = null;
      return page;
    });

    fields.push(newRevision);
  };

  return (
    <div>
      <Nav tabs>
        {fields.map((fieldName, i) => {
          return (
            <NavItem key={i}>
              <NavLink
                onClick={() => {
                  setActiveTab(fieldName);
                }}
                className={activeTab == fieldName ? "active" : ""}
              >
                Rev {fields.value[i]?.number}
              </NavLink>
            </NavItem>
          );
        })}
        <NavItem>
          <NavLink
            disabled={!canAddNewRev}
            onClick={() => {
              const lastField = _.last(fields.value);
              let cloneLast = _.cloneDeep(lastField);
              if (cloneLast) {
                cloneLast.id = null; // Remove the id so it's a new record
                cloneLast.has_records = false; // Remove has records so it's not disabled
                // Remove all id's from page_attributes
                cloneLast.pages_attributes = _.map(cloneLast.pages_attributes, (page) => {
                  page.id = null;
                  // Remove all id's from triggers_attributes
                  page.triggers_attributes = _.map(page.triggers_attributes, (trigger) => {
                    trigger.id = null;
                    // Remove all id's from actions_attributes
                    trigger.actions_attributes = _.map(trigger.actions_attributes, (action) => {
                      action.id = null;
                      return action;
                    });
                    return trigger;
                  });
                  return page;
                });
              }
              const lastNumber = lastField ? lastField.number : 0;

              fields.push({
                ...cloneLast,
                number: lastNumber + 1,
              });
              setActiveTab(`${fields?.name}[${lastNumber}]`);
            }}
          >
            <a className="link">New Revision</a>
          </NavLink>
        </NavItem>
      </Nav>

      <hr />
      <TabContent activeTab={activeTab}>
        {fields.map((fieldName, i) => {
          const fieldValue = fields.value[i];
          const hasRecords = fieldValue?.has_records;
          const disabledFields = hasRecords || i != fields.value.length - 1;
          const showForm = activeTab == fieldName;
          // Disabled if the revision has an id aka it exists in the database
          return (
            <TabPane key={fieldName} tabId={fieldName}>
              {showForm && <FieldArray
                name={`${fieldName}.pages_attributes`}
                subscription={{ length: true, value: true }}
                disabled={disabledFields}
                component={PagesAttributes}
                cloneRevision={() => {
                  cloneRevision(i);
                }}
                custom_form={custom_form}
                revisionIndex={i}
                users={users}
              />}
            </TabPane>
          );
        })}
      </TabContent>
    </div>
  );
};

export default RevisionsAttributes;
